import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Fragment } from 'react'

function classNames(...classes: string[]) {
	return classes.filter(Boolean).join(' ')
}

const links = [
	{ name: 'Programs', href: '#programs' },
	{ name: 'Class Definitions', href: '#definitions' },
	{ name: 'Attendance Policies', href: '#policies' },
]

export default function ClassDefinitions() {
	return (
		<main>
			<div className="relative isolate overflow-hidden bg-stone-900">
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="mx-auto mt-24 max-w-7xl px-6 pb-24 pt-10 sm:pb-32 lg:mt-0 lg:flex lg:items-center lg:px-8 lg:py-40">
					<div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl lg:lg:pt-8">
						<div className="inline-flex space-x-3">
							<span className="rounded-full bg-stone-100/10 px-3 py-1 text-sm font-semibold leading-6 text-stone-100">
								35th Season
							</span>
							<span className="inline-flex items-center space-x-2 text-sm font-medium leading-6 text-stone-300">
								<span>2026-27</span>
							</span>
						</div>
						<h3 className="mt-6 text-4xl font-extrabold uppercase leading-6 tracking-wide text-white md:text-6xl lg:text-7xl xl:text-8xl">
							<span className="text-[#f9c04d]">Programs,</span>
						</h3>
						<h3 className="text-4xl font-extrabold uppercase tracking-wide text-white md:text-6xl lg:text-7xl xl:text-8xl">
							Definitions
						</h3>

						<p className="text-3xl font-extrabold leading-6 text-[#f9c04d] md:text-4xl lg:mr-24 lg:text-right xl:mr-0">
							&amp; requirements
							<span className="text-stone-100">.</span>
						</p>
						<div className="py-4">
							<Menu as="div" className="relative inline-block text-left">
								{({ open }) => (
									<>
										<div>
											<Menu.Button className="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none">
												Jump to
												<ChevronDownIcon
													className="-mr-1 ml-2 h-5 w-5"
													aria-hidden="true"
												/>
											</Menu.Button>
										</div>

										<Transition
											show={open}
											as={Fragment}
											enter="transition ease-out duration-100"
											enterFrom="transform opacity-0 scale-95"
											enterTo="transform opacity-100 scale-100"
											leave="transition ease-in duration-75"
											leaveFrom="transform opacity-100 scale-100"
											leaveTo="transform opacity-0 scale-95"
										>
											<Menu.Items
												static
												className="absolute left-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg focus:outline-none"
											>
												<div className="py-1">
													{links.map((link) => (
														<Menu.Item key={link.name}>
															{({ active }) => (
																<a
																	href={link.href}
																	className={classNames(
																		active
																			? 'bg-gray-100 text-gray-900'
																			: 'text-gray-700',
																		'block px-4 py-2 text-sm',
																	)}
																>
																	{link.name}
																</a>
															)}
														</Menu.Item>
													))}
												</div>
											</Menu.Items>
										</Transition>
									</>
								)}
							</Menu>
						</div>
					</div>
					<div className="mx-auto mt-16 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32">
						<div className="max-w-3xl flex-none sm:max-w-5xl lg:max-w-none">
							<div className="-m-2 rounded-xl p-2 lg:-m-4 lg:rounded-2xl lg:p-4">
								<img
									src="/images/class-def.jpg"
									alt="Studio Students"
									width={2432}
									height={1442}
									className="w-[56rem] rounded-md shadow-2xl ring-1 ring-gray-900/10"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* <div className="h-1 bg-stone-700" /> */}

			<div className="relative isolate overflow-hidden bg-stone-900">
				<div className="absolute inset-x-0 bottom-0 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				{/* <div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
          <svg
            viewBox="0 0 1313 771"
            aria-hidden="true"
            className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
          >
            <use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
          </svg>
        </div> */}
				<div className="mx-auto max-w-7xl pb-24">
					<div id="programs" />
					<div className="grid w-full space-x-4 space-y-10 px-4 pt-6 lg:grid-cols-2 lg:space-y-4 lg:px-8 lg:pt-16">
						<div
							id="programs"
							className="text-4xl font-extrabold uppercase text-stone-100 lg:col-span-2 lg:py-8 lg:text-6xl"
						>
							<span className="text-[#f9c04d]">Programs</span>.
						</div>
						<div className="mt-4 text-stone-200 sm:p-6">
							<h2 className="text-3xl font-extrabold text-stone-100 md:text-6xl">
								Wee Dance
							</h2>
							<p className="pl-1.5 text-xl font-extrabold text-stone-400">
								AGES 18-36 MONTHS
							</p>
							<p className="py-4 pl-1.5 font-semibold">
								A creative movement class that introduces your little one to
								music, dancing, and fun with friends!
							</p>
							<dt className="text-xl font-bold text-[#f9c04d]">
								Dress Requirements
							</dt>
							<ul className="list-inside list-disc text-sm">
								<li>pink ballet shoes</li>
								<li>any kind of dance dress or leotard & skirt or tutu</li>
								<li>any color tights or socks</li>
							</ul>
						</div>
						<div className="text-stone-100 sm:p-6">
							<h2 className="text-3xl font-extrabold text-stone-100 md:text-6xl">
								Twinkling Stars
							</h2>
							<p className="pl-1.5 text-xl font-extrabold text-stone-400">
								AGES 3-5
							</p>
							<p className="py-4 pl-1.5 font-semibold">
								Through ballet & tap your future star will explore a world of
								creativity through movement, music, dance, imaginative play, &
								emotional expression. Students will learn the basics of
								classroom behavior & manners.
							</p>
							<dt className="text-xl font-bold text-[#f9c04d]">
								Dress Requirements
							</dt>
							<ul className="list-inside list-disc text-sm">
								<li>pink ballet shoes</li>
								<li>any kind of dance dress or leotard & skirt or tutu</li>
								<li>any color tights or socks</li>
								<li>black tap shoes</li>
							</ul>
						</div>
						<div className="text-stone-100 sm:p-6">
							<h2 className="text-3xl font-extrabold text-stone-100 md:text-6xl">
								Mini Movers
							</h2>
							<p className="pl-1.5 text-xl font-extrabold text-stone-400">
								AGES 5-7
							</p>
							<p className="py-4 pl-1.5 font-semibold">
								With four styles of dance offered, Ballet, Tap, Jazz, & Hip Hop,
								your young dancer will discover what they love most! Dancers
								will build a great foundation for their future in dance, all
								while building their confidence and experiencing the joy dance
								brings.
							</p>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Ballet</dt>
							<ul className="list-inside list-disc text-sm">
								<li>pink ballet shoes</li>
								<li>leotard & tights (skirts are optional)</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Tap</dt>
							<ul className="list-inside list-disc text-sm">
								<li>black tap shoes (no split sole)</li>
								<li>leotard, dance shorts, capris, leggings, etc.</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Jazz</dt>
							<ul className="list-inside list-disc text-sm">
								<li>tan jazz shoes</li>
								<li>leotard, dance shorts, capris, leggings, etc.</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Hip Hop</dt>
							<ul className="list-inside list-disc text-sm">
								<li>
									any clean sneakers for class (primarily white sneakers for
									recital)
								</li>
								<li>any dance attire or sweats, tees, tanks, etc.</li>
							</ul>
						</div>
						<div className="text-stone-100 sm:p-6">
							<h2 className="text-3xl font-extrabold text-stone-100 md:text-6xl">
								Elevate Dance
							</h2>
							<p className="pl-1.5 text-xl font-extrabold text-stone-400">
								AGES 7-9
							</p>
							<p className="py-4 pl-1.5 font-semibold">
								Whether your child is new to dance or has many years of
								experience, this program offers all the classes that will
								challenge and inspire your child. With strengthening their dance
								technique, this program continues to develop healthy social
								skills and will increase your child’s self esteem, all while
								working hard and having fun!
							</p>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Ballet</dt>
							<ul className="list-inside list-disc text-sm">
								<li>pink ballet shoes</li>
								<li>solid color leotard</li>
								<li>pink or tan tights; skirts are optional</li>
								<li>hair in a secured bun with a hairnet</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Tap</dt>
							<ul className="list-inside list-disc text-sm">
								<li>black tap shoes (no split sole)</li>
								<li>
									any dance attire: leotard, tanks, dance shorts, capris,
									leggings, sweats, etc.
								</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Jazz</dt>
							<ul className="list-inside list-disc text-sm">
								<li>tan jazz shoes</li>
								<li>
									tight fitting dance attire: leotard, tanks, dance shorts,
									capris, leggings, etc.
								</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Hip Hop</dt>
							<ul className="list-inside list-disc text-sm">
								<li>
									any clean sneakers for class (primarily white sneakers for
									recital)
								</li>
								<li>any dance attire or sweats, tees, tanks, etc.</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Lyrical</dt>
							<ul className="list-inside list-disc text-sm">
								<li>
									tan jazz shoes or bare feet (tan jazz shoes for recital)
								</li>
								<li>
									tight fitting dance attire: leotard, tanks, dance shorts,
									leggings, etc.
								</li>
							</ul>
						</div>
						<div className="text-stone-100 sm:p-6">
							<h2 className="text-3xl font-extrabold text-stone-100 md:text-6xl">
								Levels I-IV, Teen
							</h2>
							<p className="pl-1.5 text-xl font-extrabold text-stone-400">
								AGES 10 & UP
							</p>
							<p className="py-4 pl-1.5 font-semibold">
								Classes are offered for the beginner dancer all the way to a
								dancer who may want a career in dance! Dancers are encouraged to
								use dance as their emotional outlet in a place that is safe,
								welcoming, and encouraging. Classes have a strong focus on safe
								stretch and strength exercises followed by technique work for
								each specific style. Classes end with dance combinations that
								will motivate your child, with a goal of making them feel
								confident, proud, and inspired!
							</p>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Ballet</dt>
							<ul className="list-inside list-disc text-sm">
								<li>pink ballet shoes (split sole)</li>
								<li>black leotard & pink tights</li>
								<li>hair in a secured bun with a hairnet</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Tap</dt>
							<ul className="list-inside list-disc text-sm">
								<li>black tap shoes (no split sole)</li>
								<li>
									any dance attire: leotard, tanks, dance shorts, capris,
									leggings, sweats, etc.
								</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Jazz</dt>
							<ul className="list-inside list-disc text-sm">
								<li>tan jazz shoes (split sole)</li>
								<li>
									tight fitting dance attire: leotard, tanks, dance shorts,
									capris, leggings, etc.
								</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">Hip Hop</dt>
							<ul className="list-inside list-disc text-sm">
								<li>
									any clean sneakers for class (primarily white sneakers for
									recital)
								</li>
								<li>any dance attire or sweats, tees, tanks, etc.</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">
								Contemporary/Lyrical
							</dt>
							<ul className="list-inside list-disc text-sm">
								<li>
									tan jazz shoes or bare feet (tan jazz shoes for recital)
								</li>
								<li>
									tight fitting dance attire: leotard, tanks, dance shorts,
									leggings, etc.
								</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">
								Musical Theatre
							</dt>
							<ul className="list-inside list-disc text-sm">
								<li>
									jazz shoes or clean sneakers (shoes for recital based on
									costume)
								</li>
								<li>
									dance attire: leotard, tees, tanks, dance shorts, leggings,
									sweats, etc.
								</li>
							</ul>
							<dt className="pt-4 text-xl font-bold text-[#f9c04d]">
								Conditioning/Technique
							</dt>
							<ul className="list-inside list-disc text-sm">
								<li>jazz shoes or bare feet</li>
								<li>
									tight fitting dance attire: leotard, tanks, dance shorts,
									leggings, etc.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div className="h-1 bg-stone-700" />
			<div className="relative isolate overflow-hidden bg-stone-900">
				<div className="absolute inset-x-0 bottom-0 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="mx-auto max-w-4xl space-y-6 divide-y divide-stone-800 px-6 py-20 lg:grid lg:max-w-7xl lg:grid-cols-2 lg:divide-y-0 lg:px-12">
					<div
						id="definitions"
						className="text-4xl font-extrabold uppercase text-stone-100 lg:col-span-2 lg:py-8 lg:text-6xl"
					>
						<span className="text-[#f9c04d]">Class</span>
						<span className="block">
							Definitions
							<span className="text-[#f9c04d]">.</span>
						</span>
					</div>
					<div className="mt-6 flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Wee Dance
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							creative movement class that introduces your little one to music,
							dancing, and fun with friends!
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Twinkling Stars
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							through ballet & tap your future star will explore a world of
							creativity through movement, music, dance, imaginative play, &
							emotional expression. Students will learn the basics of classroom
							behavior & manners.
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Ballet
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							terminology and classical technique using barre and center.
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Ballet Tech
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							will focus on strengthening ballet technique. No recital dance.
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Pointe
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							a part of classical ballet technique in which a dancer supports
							all body weight on the tips of fully extended feet within pointe
							shoes.
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Tap
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							a form of dance characterized by using the sounds of tap shoes
							striking the floor as a form of percussion.
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Hip Hop
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							a street style form of dance that has evolved through urban
							culture.
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Jazz
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							high-energy dance includes floor stretch, isolations and
							combinations. Enrollment in a ballet class is recommended.
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Contemporary
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							an always evolving style of dance that incorporates aspects of
							movement in other genres such as modern, ballet, and jazz.
							Enrollment in a ballet class is recommended.
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Lyrical
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							expressive dance combined with ballet and jazz technique.
							Enrollment in ballet or jazz is recommended.
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Musical Theatre
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							through acting, singing, and dancing this class will bring out the
							performer in you!
						</div>
					</div>
					<div className="flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Conditioning/Technique
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							Stretch and strengthening exercises to support dance training
							along with a focus on turns and leaps. Enrollment in ballet and
							jazz is required. No recital dance.
						</div>
					</div>
				</div>
			</div>
			<div className="h-1 bg-stone-100" />
			<div className="relative isolate overflow-hidden bg-stone-900">
				<div className="absolute inset-x-0 bottom-0 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				{/* <div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
          <svg
            viewBox="0 0 1313 771"
            aria-hidden="true"
            className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
          >
            <use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
          </svg>
        </div> */}
				<div className="mx-auto max-w-4xl space-y-6 divide-y divide-stone-800 px-4 py-20 lg:max-w-7xl lg:px-12">
					<div
						id="policies"
						className="text-4xl font-extrabold uppercase text-stone-100 lg:col-span-2 lg:py-8 lg:text-6xl"
					>
						<span className="text-[#f9c04d]">Attendance</span>
						<span className="block">
							Policies
							<span className="text-[#f9c04d]">.</span>
						</span>
					</div>
					<div className="mt-6 flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="pt-6 text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Absentees and make-up classes
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							If your child misses a class due to illness or weather, she/he may
							make it up in another class that corresponds to her/his age and
							level. Missed classes must be made up within the dance year. No
							refunds, transfers or credits are allowed. Please call the studio
							when your child is absent from class.
						</div>
					</div>
					<div className="mt-6 flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="pt-6 text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Weather
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							In the event of serious weather conditions, studio closings will
							be posted on our website, social media sites, and voicemail
							system. Classes canceled due to weather can be made-up at anytime
							during the dance year.
						</div>
					</div>
					<div className="mt-6 flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="pt-6 text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Lost & Found
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							The lost & found items are located in the benches in the reception
							area. Items not claimed will be donated to charities on a
							quarterly basis. We encourage all students to label all shoes,
							dance bags, and clothing. Stage Door Dance Academy is not
							responsible for lost or stolen articles.
						</div>
					</div>
					<div className="mt-6 flex-col items-center justify-center space-y-2 pt-4 lg:space-y-0 lg:pt-0">
						<div className="pt-6 text-3xl font-extrabold text-[#f9c04d] lg:text-3xl">
							Student Lounge
						</div>
						<div className="text-base leading-6 text-stone-100 sm:pr-10">
							Stage Door Dance Academy is fortunate to have a student lounge
							where students may rest, eat, socialize, or study between classes.
							So that all students may continue to enjoy student lounge
							privileges, the following must be adhered to at all times:
							<ul className="list-inside list-disc py-4">
								<li>Keep the noise level down.</li>
								<li>All trash must go in garbage can.</li>
								<li>All food and drink must be consumed in lounge only.</li>
								<li>Water is the only beverage allowed in studios.</li>
								<li>
									Gum is prohibited in the studios, lounge, and indoor premises.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</main>
	)
}
